module.exports = __webpack_public_path__ + "media/icons/scroll@3x-ba4fa39d.svg";